import {
  VARIABLE_TYPE_ARRAY,
  isArrayVariable,
  normalizeArrayValues,
} from './types';

/** How many non-empty value slots a row has (arrays count each filled entry). */
export const countFilledVariableSlots = (row) => {
  if (!row) return 0;
  if (isArrayVariable(row)) {
    return (Array.isArray(row.values) ? row.values : []).filter(
      (v) => String(v ?? '').trim() !== ''
    ).length;
  }
  return String(row.value ?? '').trim() !== '' ? 1 : 0;
};

/** Wipe unlocked values; array rows keep their slot count. */
export const clearVariableRowValues = (row) => {
  if (!row) return row;
  if (isArrayVariable(row)) {
    const values = normalizeArrayValues(row.values).map(() => '');
    return { ...row, type: VARIABLE_TYPE_ARRAY, values, value: '' };
  }
  return { ...row, value: '' };
};

/** Empty unlocked rows only — locked template values stay put. */
export const clearUnlockedVariableValues = (variables) => {
  if (!Array.isArray(variables) || variables.length === 0) return variables;
  return variables.map((v) => (v?.locked ? v : clearVariableRowValues(v)));
};

export const hasUnlockedFilledVariableValues = (variables) => {
  if (!Array.isArray(variables)) return false;
  return variables.some((v) => v && !v.locked && countFilledVariableSlots(v) > 0);
};
